import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    Button,
    notification,
    Form,
    Input,
    Select,
} from "antd";
import apiClient from "../../services/api";
import { useNavigate, useParams } from "react-router-dom";
import JoditEditor from "jodit-react";
import { handleApiError, handleApiSuccess, handleApiInfo } from "../../utils/errorHandler";
import logger from "../../utils/logger";

const { Item } = Form;
const { Option } = Select;

function FaqAdd() {
    const { faqId } = useParams(); // Extract faqId from URL
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [isUpdateMode, setIsUpdateMode] = useState(false);

    useEffect(() => {
        // Check if faqId exists to determine if it's an update mode
        if (faqId) {
            setIsUpdateMode(true);
            fetchFaqDetails();
        }
    }, [faqId, form]);

    const fetchFaqDetails = async () => {
        try {
            const response = await apiClient.get(`/api/faq/read/${faqId}`);
            if (response.status === 200) {
                form.setFieldsValue(response.data.result);
            } else {
                handleApiInfo(response.data.message);
            }
        } catch (error) {
            handleApiError(error);
            logger.error("API error:", error);
        }
    };

    const onFinish = async (values) => {
        try {
            if (isUpdateMode) {
                const response = await apiClient.patch(`/api/faq/${faqId}`, values);
                if (response.status === 200) {
                    handleApiSuccess('Faq updated successfully!');
                    navigate('/faq');
                } else {
                    handleApiInfo(response.data.message);
                }
            } else {
                const response = await apiClient.post('/api/faq', values);
                if (response.status === 200) {
                    handleApiSuccess('Faq added successfully!');
                    form.resetFields();
                    navigate('/faq');
                } else {
                    handleApiInfo(response.data.message);
                }
            }
        } catch (error) {
            handleApiError(error);
            logger.error("API error:", error);
        }
    };

    return (
        <div className="tabled">
            <Row gutter={[24, 0]}>
                <Col xs="24" xl={24}>
                    <Card
                        bordered={false}
                        className="criclebox tablespace mb-24"
                        title={isUpdateMode ? "Update Faq" : "Add Faq"}
                    >
                        <Form style={{ "padding": "20px" }} form={form} onFinish={onFinish} layout="vertical">
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Question"
                                        name="question"
                                        rules={[{ required: true, message: 'Please enter question.' }]}
                                    >
                                        <Input />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Answer"
                                        name="answer"
                                        rules={[{ required: true, message: 'Please enter answer.' }]}
                                    >
                                        <JoditEditor />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Status"
                                        name="enabled"
                                        rules={[{ required: true, message: 'Please select status.' }]}
                                    >
                                        <Select placeholder="Please select status">
                                            <Option value={true}>Active</Option>
                                            <Option value={false}>Inactive</Option>
                                        </Select>
                                    </Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item>
                                        <Button type="primary" htmlType="submit">
                                            {isUpdateMode ? "Update" : "Add"}
                                        </Button>
                                    </Item>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default FaqAdd;
